<template>
  <div class="od-container" :class="{'px-0': isMobile}" id="doctor">
    <section class="doctor_info">
      <div class="tbox" data-aos="fade-up">
        <p class="t01"><img v-lazy="`${publicPath}img/intro/sub_01_img_02.png`"></p>
        <p class="t02">보건복지부 인증 <b>전문의 4인 협진</b></p>
      </div>
      <div class="bg"></div>
      <img v-lazy="`${publicPath}img/intro/m_sub_self_00.png`" class="mobile">
    </section>

    <section class="doctor_list">
      <ul class="web">
        <li>
          <div class="info"><img v-lazy="`${publicPath}img/intro/sub_01_self_01.png`"></div>
        </li>
        <li>
          <div class="info"><img v-lazy="`${publicPath}img/intro/sub_01_self_02.png`"></div>
        </li>
        <li>
          <div class="info"><img v-lazy="`${publicPath}img/intro/sub_01_self_03.png`"></div>
        </li>
        <li>
          <div class="info"><img v-lazy="`${publicPath}img/intro/sub_01_self_04.png`"></div>
        </li>
      </ul>
      <ul class="mobile">
        <li><img v-lazy="`${publicPath}img/intro/m_sub_self_01.png`"></li>
        <li><img v-lazy="`${publicPath}img/intro/m_sub_self_02.png`"></li>
        <li><img v-lazy="`${publicPath}img/intro/m_sub_self_03.png`"></li>
        <li><img v-lazy="`${publicPath}img/intro/m_sub_self_04.png`"></li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'IntroTeam',
};
</script>

<style scoped>

</style>
